import { useEffect, useState } from "react";

import { AuthPagePaper } from "../Auth/components/AuthPagePaper";
import { linksConstants } from "../../../constants/linksConstants";
import { createTestId } from "../../../utils/createTestId";
import Button from "@demystdata/ui/button";
import { Switch } from "../../components/formComponents/Switch";
import { AnimatePresence, motion } from "framer-motion";
import { MessageBox } from "../../components/MessageBox/MessageBox";
import { animatePresenceConfig } from "../../../config/appConfig";
import Link from "next/link";

export const CookiesPreferences = () => {
  const [performance, setPerformance] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setPerformance(getCookies()["_manta_cookies"] !== "necessary_only");
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    document.cookie = `_manta_cookies=${performance ? "all" : "necessary_only"};expires=${new Date(
      Date.now() + 24 * 3600000 /* ms in hours */ * 365,
    )}`;
    if (!performance) deletePerformanceCookies();
    setSuccess(true);
    setTimeout(() => setSuccess(false), 10000);
  };

  return (
    <>
      <main role="main" className="cookie-preferences">
        <div className="cookie-preferences__paper">
          <AuthPagePaper>
            <header
              data-test-id={createTestId("loginPageHeader")}
              className="cookie-preferences__paper__header"
            >
              <h1 className="cookie-preferences__paper__header__title">
                Manage Cookie Preferences
              </h1>
            </header>
            <section className="cookie-preferences__footer__policy">
              <p>
                Demyst would like your permission to use your data for the following purposes;
                toggle your cookie permissions below. View
                <Link href={linksConstants.COOKIE_POLICY}> Cookie Policy</Link>.
              </p>
            </section>
            <form onSubmit={handleSubmit} className="cookie-preferencesForm">
              <div className="cookie-preferences_option">
                <div className="cookie-preferences_option_text">
                  <h2>Necessary Cookies</h2>
                  <p>
                    Necessary Cookies These cookies are required for good functionality of our
                    website and can't be switched off in our system.
                  </p>
                </div>
                <div className="cookie-preferences_option_toggle">
                  <Switch
                    id={"necesary-cookie"}
                    name={"necesary-cookie"}
                    disabled
                    value={true}
                    defaultChecked={true}
                    onLabelText=""
                    offLabelText=""
                  />
                </div>
              </div>
              <div className="cookie-preferences_option">
                <div className="cookie-preferences_option_text">
                  <h2>Performance Cookies</h2>
                  <p>
                    We use these cookies to provide statistical information about our website - they
                    are used for performance measurement and improvement.
                  </p>
                </div>
                <div className="cookie-preferences_option_toggle">
                  <Switch
                    id={"performance-cookie"}
                    name={"performance-cookie"}
                    value={performance}
                    defaultChecked={performance}
                    onChange={() => setPerformance(!performance)}
                    onLabelText=""
                    offLabelText=""
                  />
                </div>
              </div>
              <Button type="submit" size="large" variant="primary">
                Save Changes
              </Button>
            </form>
          </AuthPagePaper>
        </div>
      </main>
      {success && (
        <AnimatePresence>
          <motion.div className="cookie-preferences_success-message" {...animatePresenceConfig}>
            <MessageBox type="success">
              <div>
                <strong>Changes saved!</strong>
                <p>Your cookie preferences have been updated.</p>
              </div>
            </MessageBox>
          </motion.div>
        </AnimatePresence>
      )}
    </>
  );
};

const LIST_OF_COOKIES_TO_DELETE = [
  "_lr_tabs_-vwmbbx%2Fdemyst",
  "_lr_uf_-vwmbbx",
  "_lr_hb_-vwmbbx%2Fdemyst",
  "_gid",
  "_ga",
  "_gat",
];

const getCookies = () => {
  return document.cookie
    .split(";")
    .map(v => v.split("="))
    .reduce((acc, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});
};

const getCookie = name => getCookies()[name];

const deleteCookie = name => {
  if (getCookie(name)) document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};

const deletePerformanceCookies = () => LIST_OF_COOKIES_TO_DELETE.forEach(deleteCookie);
